import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LayoutComponent } from "../layout/layout.component";
import { EndorseNameAppNoComponent } from "./endorse-name-app-no.component";

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    children: [
      {
        path: 'endorse-name-app-no',
        component: EndorseNameAppNoComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndorseNameAppNoRoutingModule { }
